export enum AdminTourAveragesUnits {
  deg = 'deg',
  mph = 'mph',
  rpm = 'rpm',
  yards = 'yards',
  withoutUnit = '',
}

export const clubs = [
  { key: 'driver', name: 'Driver' },
  { key: 'threeWood', name: '3-Wood' },
  { key: 'fiveWood', name: '5-Wood' },
  { key: 'hybrid', name: 'Hybrid' },
  { key: 'threeIron', name: '3 Iron' },
  { key: 'fourIron', name: '4 Iron' },
  { key: 'fiveIron', name: '5 Iron' },
  { key: 'sixIron', name: '6 Iron' },
  { key: 'sevenIron', name: '7 Iron' },
  { key: 'eightIron', name: '8 Iron' },
  { key: 'nineIron', name: '9 Iron' },
  { key: 'pitchingWedge', name: 'PW' },
] as const;

export type ClubKey = (typeof clubs)[number]['key'];

export type AdminClubsScores = Partial<Record<ClubKey, number | null>>;

export type TourAverageParameterOption = {
  id: string;
  title: string;
  categoryLabel: string;
};

export type TourAveragesParameter = {
  unit?: string;
  parameterId: string;
  parameterName?: string;
  clubs: AdminClubsScores;
};

export type NewTourParameterData = Pick<TourAveragesParameter, 'parameterId' | 'unit'>;

export enum TourAveragesVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export type TourAveragesData = {
  id?: string;
  version: TourAveragesVersion;
  year: number | null;
  pga: TourAveragesParameter[];
  lpga: TourAveragesParameter[];
};
